import { EntryKinds, isInputEntry } from '@i-ark/models';
import { selectPageEntryById } from './entry.page-by-id.js';

const selectItemInputEntryById = (pageId, itemId) => data => {
  const page = selectPageEntryById(pageId)(data);
  const item = {
    entry: page.items[itemId]?.entry ?? {
      kind: EntryKinds.INPUT,
      value: ""
    }
  };
  if (!isInputEntry(item.entry)) {
    throw new Error("selectInputEntryById(): Entry is not of type input");
  }
  return item.entry;
};

export { selectItemInputEntryById };
//# sourceMappingURL=entry.item-input-by-id.js.map
